import { getCountries } from 'libphonenumber-js'
import labels from 'react-phone-number-input/locale/en.json'

/** Ported from react-phone-number-input/modules/phoneInputHelpers */
export const getCountrySelectOptions = (
  countries = getCountries(),
  countryNames = labels,
) => {
  const countrySelectOption = countries.map((country) => ({
    value: country,
    label: countryNames[country] || country,
  }))

  return countrySelectOption.sort(
    ({ label: aLabel }, { label: bLabel }) => (aLabel < bLabel ? -1 : aLabel > bLabel ? 1 : 0))
}

export const countries = getCountrySelectOptions()

